module.exports = __webpack_public_path__ + "static/media/icon.9966e768.png";